import { singleton } from "tsyringe";
import { paintingsData, TPaintingData } from "./config/paintings";

@singleton()
export class AppState {
  isAmbient = false;
  isSliderVisited = false;
  private _activePainting: string;
  goNextPainting() {
    this.activePainting = paintingsData[this.nextPaintingIdx].key;
  }
  goPrevPainting() {
    this.activePainting = paintingsData[this.prevPaintingIdx].key;
  }
  get activePainting(): string {
    return this._activePainting;
  }
  get activePaintingIdx(): number {
    return paintingsData.findIndex((p) => p.key === this.activePainting);
  }
  get nextPaintingIdx(): number {
    const idx = this.activePaintingIdx;
    return paintingsData[idx + 1] ? idx + 1 : 0;
  }
  get nextPainting(): TPaintingData {
    return paintingsData[this.nextPaintingIdx];
  }
  get prevPainting(): TPaintingData {
    return paintingsData[this.prevPaintingIdx];
  }
  get prevPaintingIdx(): number {
    const idx = this.activePaintingIdx;
    return paintingsData[idx - 1] ? idx - 1 : paintingsData.length - 1;
  }
  get activePaintingData(): TPaintingData {
    return paintingsData.find(({ key }) => key === this._activePainting);
  }
  set activePainting(key: string) {
    this._activePainting = key;
  }
}
